import { StorageKey } from "../../../../../cache/LocalCache"
import type { ResourceFilterElementValue, ResourceFiltersSelectedItem } from "../../../createOrderTypes"

import { readPerUserStorage, writePerUserStorage } from "./perUserStorage"

export const SERVICE_CENTER_FILTER_IDENTIFIER = "serviceCenterIds"

function isKeyOrValue(value: unknown): value is string | number {
    return typeof value === "string" || typeof value === "number"
}

function isFilterValue(value: unknown): value is ResourceFilterElementValue {
    if (typeof value !== "object" || value === null) return false

    return "key" in value && "value" in value && isKeyOrValue(value.key) && isKeyOrValue(value.value)
}

const parseSelection = (values: unknown): ResourceFilterElementValue[] | undefined => {
    const filterValues = Array.isArray(values) ? values.filter(isFilterValue) : []
    return filterValues.length ? filterValues : undefined
}

const readStoredSelections = () => readPerUserStorage(StorageKey.CREATE_ORDER_TIMELINE_LOCATIONS, parseSelection)

function isSameSelection(
    a: ReadonlyArray<ResourceFilterElementValue>,
    b: ReadonlyArray<ResourceFilterElementValue>,
): boolean {
    return (
        a.length === b.length && a.every((value, index) => value.key === b[index].key && value.value === b[index].value)
    )
}

/** The saved selection as a filter row, ready to spread into the timeline's initial filters. */
export function loadServiceCenterFilter(userId: number): ResourceFiltersSelectedItem[] {
    const values = readStoredSelections()[String(userId)]

    return values?.length ? [{ identifier: SERVICE_CENTER_FILTER_IDENTIFIER, values }] : []
}

export function saveServiceCenterFilter(userId: number, values: ReadonlyArray<ResourceFilterElementValue>): void {
    const stored = readStoredSelections()
    const userKey = String(userId)

    if (isSameSelection(stored[userKey] ?? [], values)) return

    if (values.length) {
        stored[userKey] = values.map((value) => ({ ...value }))
    } else {
        // No entry means "all locations", which is what an empty selection means too.
        delete stored[userKey]
    }

    writePerUserStorage(StorageKey.CREATE_ORDER_TIMELINE_LOCATIONS, stored)
}
